export const en = {
    translation: {
        common: {
            trial: "Trial Version",
            expired: "Expired",
            renewal: "Renewal",
            quantity: "Qty",
            error: "Error",
            all: "All",
            loading: "Loading...",
            thank_you: "Thank You",
            confirm: "Confirm",
            cancel: "Cancel",
            save: "Save",
            add: "Add",
            edit: "Edit",
            delete: "Delete",
            warning: "Warning",
            delete_confirm_text: "This action cannot be undone. Are you sure you want to delete?",
            click_to_select: "Select...",
            unit: "Unit",
            detail: "Detail",
            done: "Done",
            search: "Search",
            processing: "Processing...",
            success: "Success",
            total: "Total",
            none: "None"
        },
        receipt: {
            info_slip: "INFORMATION SLIP",
            no_value: "NO FINANCIAL VALUE"
        },
        roles: {
            admin: "Admin",
            barista: "Barista",
            waiter: "Waiter",
            kitchen: "Kitchen"
        },
        auth: {
            user_not_found: "User not found!",
            welcome: "Welcome Back",
            subtitle: "Sign in to manage your coffee shop",
            google_login: "Sign in with Google",
            apple_login: "Sign in with Apple",
            secure_login: "Secure Login",
            terms_text: "By signing in, you agree to our Terms of Service and Privacy Policy.",
            alerts: {
                google_failed: "Login failed. Please try again.",
                restore_admin: "Emergency: Restore Admin Role?",
                admin_success: "SUCCESS: User '{{name}}' is now Admin ('{{role}}'). Please login.",
                no_staff: "ERROR: No staff data loaded yet. Please wait a moment and try again."
            }
        },
        sidebar: {
            dashboard: "Dashboard",
            tables: "Tables",
            staff: "Staff",
            loyalty: "CRM & Loyalty",
            qr_menu: "QR Menu",
            menu_product: "Menu & Products",
            stock_recipe: "Stock & Recipe",
            reports: "Reports",
            settings: "Settings",
            admin_panel: "Admin Panel",
            not_logged_in: "Not Logged In",
            click_to_select: "Select Profile",
            switch_profile: "Switch Profile",
            logout: "Logout"
        },
        dashboard: {
            overview: "Dashboard Overview",
            today: "Today",
            system_active: "System Active",
            offline: "Offline Mode",
            payment_reminder: "Completion Reminder",
            payment_missing_list: "Completion for {{names}} has not been made yet.",
            add_expense: "Add Expense",
            daily_revenue: "Daily Revenue",
            open_tables: "Open Tables",
            pending_tables: "Pending Orders",
            waiting_approval: "Waiting Approval",
            active_staff: "Active Staff",
            hourly_revenue: "Hourly Revenue",
            hourly_profit: "Hourly Profit",
            work_hours: "Work Hours",
            hours_24: "24 Hours",
            revenue: "Revenue",
            profit: "Profit",
            best_sellers: "Best Sellers",
            support_modal: { other: "Other" },
            weekly_performance: "Weekly Performance",
            weekly_revenue: "Weekly Revenue",
            increase: "Increase",
            decrease: "Decrease",
            busiest_day: "Busiest Day",
            view_report: "View Report",
            critical_stock_warning: "Critical Stock",
            quick_actions: "Quick Actions",
            x_report: "X Report",
            sync: "Sync",
            backup: "Backup",
            support: "Support",
            help_support: "Help & Support",
            help_desc: "How can we help you?",
            report_issue: "Report Issue",
            version: "Version",
            topic: "Topic",
            technical: "Technical Issue",
            suggestion: "Suggestion",
            other: "Other",
            description: "Description",
            desc_placeholder: "Please describe the issue...",
            send_report: "Send Report"
        },
        tables: {
            status: {
                occupied: "Occupied",
                paid: "Completed",
                reserved: "Reserved",
                empty: "Empty"
            },
            alerts: {
                reservation_time: "Reservation Time:",
                draft_paid: "Completed Draft Order",
                draft_unpaid: "Draft Order"
            },
            title: "Table Plan",
            tabs: {
                plan: "Plan",
                history: "History"
            },
            filter: {
                all: "All"
            },
            actions: {
                finish_edit: "Finish Editing",
                edit: "Edit Tables",
                add_table: "Add Table",
                quick_pay: "Quick Complete",
                reserve: "Reserve",
                clear: "Clear"
            },
            card: {
                capacity: "Person",
                just_now: "Just now",
                total: "Total",
                has_request: "New Request",
                no_order: "No Order"
            },
            history: {
                search_placeholder: "Search Ticket No or Table...",
                multi_pay: "Multi Pay"
            },
            sections: {
                manage: "Manage Sections",
                add_placeholder: "New Section Name",
                no_sections: "No sections defined."
            },
            modal: {
                edit_title: "Edit Table",
                add_title: "Add Table",
                name: "Table Name",
                name_placeholder: "e.g. Table 5",
                section: "Section",
                capacity: "Capacity",
                delete: "Delete Table",
                unpaid_warning_title: "Incomplete Balance!",
                clear_confirm_title: "Clear Table?",
                unpaid_warning_text: "<b>{{name}}</b> has incomplete balance. Clearing it will reset the order.",
                clear_confirm_text: "Are you sure you want to clear <b>{{name}}</b>?",
                delete_confirm_text: "Are you sure you want to delete <b>{{name}}</b>?"
            },
            qr_review: {
                title: "Incoming QR Order",
                subtitle: "New request from {{name}}",
                current_state: "Current Table State",
                table_empty: "Table is currently empty.",
                current_total: "Current Total",
                incoming_request: "Incoming Request",
                extra_total: "Extra Total",
                reject: "Reject",
                overwrite: "Overwrite",
                overwrite_desc: "Clear current & set new",
                merge: "Merge",
                merge_desc: "Add to existing"
            }
        },
        orders: {
            status: {
                completed: "Completed"
            },
            list: {
                ticket_no: "Ticket No",
                date: "Date/Time",
                table: "Table/Customer",
                method: "Method",
                amount: "Amount",
                status: "Status"
            },
            modal: {
                match_error: "Record total ({{pay}}₺) does not match order total ({{total}}₺).",
                title: "Transaction Details",
                content_title: "Order Content",
                total_title: "Total Amount",
                payment_details: "Record Details",
                entered_total: "Entered Total",
                difference: "Difference"
            },
            correction: {
                note_placeholder: "e.g. Wrong entry by staff"
            },
            void_flow: {
                button_update: "Update Status / Void",
                button_void: "Void / Refund",
                title_select: "Select Void Type",
                type_cancel: "Error / Return",
                type_cancel_desc: "Restores Stock",
                type_wastage: "Wastage / Spilled",
                type_wastage_desc: "Deducts Stock (No Return)",
                confirm_cancel_title: "Mark as Error/Return",
                confirm_wastage_title: "Mark as Wastage",
                confirm_cancel_text: "This will cancel the sale and restore all stock to inventory. Are you sure?",
                confirm_wastage_text: "This will cancel the sale but stock will be considered USED/LOST. Are you sure?",
                confirm: "CONFIRM"
            }
        },
        pos: {
            title_quick: "Quick Operation",
            title_no_table: "No Table",
            title_table: "{{name}}",
            search_placeholder: "Search Product...",
            grid: {
                sold_out: "SOLD OUT"
            },
            ticket: {
                title: "Current Order",
                order_no: "ORDER NO",
                new: "NEW",
                empty: "Cart is empty.",
                status: {
                    wastage: "WASTAGE",
                    comp: "COMP",
                    cancelled: "CANCELLED",
                    paid: "COMPLETED"
                },
                discount_badge: "OFF"
            },
            actions: {
                discount: "DISCOUNT",
                comp: "COMP",
                void: "WASTAGE",
                cancel: "CANCEL",
                pay: "COMPLETE",
                assign_table: "TABLE",
                save: "SAVE",
                waiting_payment: "WAITING COMPLETION",
                close_ticket: "FINALIZE",
                transfer: "TRANSFER",
                confirm_transfer: "CONFIRM TRANSFER"
            },
            totals: {
                subtotal_net: "Subtotal (Net)",
                tax_vat: "Tax (VAT)",
                grand_total: "Grand Total",
                tax_exclusive_hint: "(+Tax)"
            },
            alerts: {
                table_not_found: "Table not found.",
                perm_comp: "You do not have permission to offer comps.",
                perm_void: "You do not have permission to void items.",
                select_item_error: "Please select an item.",
                paid_item_error: "Completed items cannot be modified.",
                split_quantity: "How many of {{count}} items to move?",
                invalid_amount: "Invalid amount.",
                perm_discount: "You do not have permission to apply discounts.",
                select_discount_item: "Select an item to discount.",
                paid_discount_error: "Cannot discount completed items.",
                add_items_first: "Please add items to cart first.",
                unauthorized: "Access Denied",
                transfer_error_quick: "Item transfer is not available in Quick Order.",
                no_financial_value: "The transaction on this page has no financial value"
            },
            modifier_modal: {
                no_modifiers: "No modifiers available.",
                multiple: "multiple",
                add_to_cart: "Add to Cart"
            },
            discount_modal: {
                title: "Apply Discount",
                percent: "Percentage",
                amount: "Amount",
                comp_100: "COMP (100%)",
                old_total: "Old Total",
                new_total: "New Total",
                apply: "Apply Discount"
            },
            transfer: {
                select_target: "Select Target Table",
                merge: "MERGE",
                move: "MOVE"
            }
        },
        payment: {
            alerts: {
                enter_valid: "Please enter a valid amount.",
                balance_not_zero: "Remaining balance must be 0 to close ticket."
            },
            header_order: "Order",
            header_open: "Active Order",
            ticket_details: "Order Details",
            select_all: "Select All",
            items_count: "{{count}} Items",
            empty_list: "No Items",
            remaining_badge: "Left: {{amount}}",
            recent_transactions: "RECENT RECORDS",
            totals: {
                total: "Total",
                paid: "Recorded",
                remaining: "Remaining"
            },
            amount_to_collect: "Total",
            give_change: "Difference",
            return_to_customer: "Return",
            methods: {
                cash: "Cash Record",
                card: "Credit Card Record",
                qr: "QR / Mobile Record",
                other: "Meal Card Record"
            },
            numpad: {
                all: "All"
            },
            actions: {
                cancel: "Cancel",
                close_ticket: "Finalize",
                waiting_payment: "Waiting Completion"
            }
        },
        menu: {
            title: "Menu Management",
            subtitle: "Manage products, prices and stock",
            add_new: "Add Product",
            edit_title: "Edit Product",
            add_title: "Add Product",
            manage_categories: "Manage Categories",
            alerts: {
                no_permission: "You do not have permission to manage menu.",
                delete_confirm: "Are you sure you want to delete this product?"
            },
            form: {
                image_select: "Select Image",
                image_change: "Change Image",
                image_recommendation: "Square format recommended",
                image_max_size: "Max 2MB",
                name: "Product Name",
                name_placeholder: "e.g. Latte",
                category: "Category",
                price: "Price",
                stock_tracking: "Stock Tracking",
                stock_hint: "Leave 0 to disable",
                description: "Description",
                description_placeholder: "Ingredients, details...",
                customizable: "Customizable (Modifiers)"
            },
            categories: {
                title: "Category Management",
                add: "Add Category",
                name: "Category Name",
                edit: "Edit Category",
                delete_confirm: "Delete this category?"
            }
        },
        categories: {
            all: "All",
            hot_coffees: "Hot Coffees",
            cold_coffees: "Cold Coffees",
            desserts: "Desserts",
            snacks: "Snacks",
            barista_special: "Special"
        },
        stock: {
            title: "Inventory Management",
            subtitle: "Stock, Recipes and Modifiers",
            tabs: {
                inventory: "Inventory",
                recipes: "Recipes",
                modifiers: "Modifiers"
            },
            inventory: {
                total_value: "Total Value",
                sku_count: "SKU Count",
                alerts_header: "Stock Alerts",
                search_placeholder: "Search Stock...",
                add_stock: "Add Item",
                status_critical: "Critical",
                status_warning: "Low",
                status_sufficient: "OK",
                table: {
                    name: "Name",
                    supplier: "Supplier",
                    amount: "Amount",
                    status: "Status",
                    unit_cost: "Unit Cost",
                    actions: "Actions"
                },
                modal: {
                    edit_title: "Edit Stock",
                    add_title: "Add Stock",
                    general_info: "General Info",
                    management: "Management",
                    name: "Item Name",
                    name_placeholder: "e.g. Milk",
                    supplier: "Supplier",
                    supplier_placeholder: "e.g. Local Farm",
                    unit: "Unit",
                    alarm_thresholds: "Alarm Thresholds",
                    warning_limit: "Warning Limit",
                    critical_limit: "Critical Limit",
                    stock_status: "Stock Status",
                    finish_editing: "Finish Editing",
                    manual_correction: "Manual Correction",
                    current_amount: "Current Amount",
                    unit_cost: "Unit Cost",
                    new_purchase: "New Purchase / Entry",
                    add_amount: "Add Amount",
                    purchase_price: "Purchase Price",
                    total: "Total",
                    unit_price: "Unit Price",
                    success_feedback: "Updated!",
                    calculate_add: "Calculate & Add",
                    avg_cost_note: "* Calculates weighted average cost."
                },
                alerts_title: "Alerts",
                alerts: {
                    invalid_amount: "Please enter a valid amount.",
                    ingredient_exists: "Ingredient already in recipe. Double click item to update amount."
                }
            },
            wastage: {
                title: "Report Wastage",
                subtitle: "Reporting wastage for {{name}}",
                amount: "Amount",
                reason: "Reason",
                reason_placeholder: "e.g. Spilled, Spoiled",
                report: "Report Wastage"
            },
            recipes: {
                search_product: "Search product...",
                gross_margin: "Gross Margin",
                sale_price: "Sale Price",
                cost_price: "Cost Price",
                ingredients: "Ingredients",
                no_recipe: "No recipe defined.",
                add_ingredient: "Add Ingredient",
                stock_item: "Stock Item",
                amount: "Amount",
                unit: "Unit",
                select_product: "Select a product from the list",
                edit_title: "Edit Recipe"
            },
            modifiers: {
                title: "Modifier Groups",
                new_group: "New Group",
                group_name: "Group Name",
                selection_type: "Selection Type",
                single: "Single (Radio)",
                multiple: "Multiple (Checkbox)",
                options: "Options",
                option_name: "Option Name",
                option_placeholder: "e.g. Oat Milk",
                extra_price: "Extra Price",
                deduct_stock: "Deduct Stock (Optional)",
                add_option: "Add Option",
                group_helper_text: "Manage options for this group below.",
                no_link: "No Link",
                stock_optional_label: "Stock (Optional)",
                edit_group_title: "Edit Group",
                allow_multiple_label: "Allow multiple selections (Checkbox)",
                delete_group_confirm: "Are you sure you want to delete this group?",
                select_group_hint: "Select a group from left or create new",
                edit_option_title: "Edit Option",
                creating_group: "Creating New Group...",
                no_options: "No options added yet."
            }
        },
        reports: {
            title: "Financial Overview",
            filters: { today: "Today", week: "Week", month: "Month", all: "All" },
            kpi: {
                revenue: "Total Revenue",
                net_revenue: "Net Revenue (Excl. Tax)",
                tax_collected: "Tax Collected",
                income: "Income",
                expense: "Total Expense",
                expense_opr: "Operational",
                expense_stock: "COGS",
                expense_wastage: "Wastage",
                profit: "Net Profit",
                profit_opr: "Operating Profit",
                cash_in_hand: "Cash Flow",
                gross_profit: "Gross Profit",
                tickets: "Total Tickets",
                sales_count: "Sales Count",
                expense_analysis: "Expense Analysis",
                profit_analysis: "Net Profit Analysis",
                available_in_standard: "Available in Standard Plan",
                locked: "Locked"
            },
            toggles: {
                stock_cost: "Stock Cost",
                wastage: "Wastage",
                operational: "Operational Mode",
                net_revenue: "Net Revenue (Tax)"
            },
            charts: {
                sales_title: "Sales Chart ({{currency}})",
                hourly: "Hourly",
                daily: "Daily",
                monthly: "Monthly",
                distribution: "Distribution",
                category_breakdown: "Category Breakdown",
                revenue_share: "Revenue Share",
                no_data: "No data.",
                tooltip_revenue: "Revenue: ",
                tooltip_net_revenue: "Net Revenue: ",
                tooltip_profit: "Profit: "
            },
            transactions: {
                title: "Transaction History",
                count_listed: "{{count}} Records Listed",
                table: {
                    ticket_no: "Ticket No",
                    date: "Date / Time",
                    table: "Table",
                    method: "Method",
                    amount: "Amount",
                    status: "Status"
                },
                status: {
                    completed: "Completed",
                    cancelled: "Cancelled"
                },
                no_records: "No transactions found in selected range."
            },
            x_report: {
                title: "Instant Cash Report (X-Report)",
                total_cash: "Total Cash in Register",
                daily_tickets: "Daily Tickets",
                cancelled_trx: "Cancelled Transactions",
                collections: "Collections (Current)",
                shift_reports: "Staff Shift Reports (Today)",
                no_shift: "No shift reports yet.",
                total_sales: "TOTAL SALES",
                cash: "Cash",
                credit_card: "Credit Card",
                qr_mobile: "QR / Mobile",
                meal_card: "Meal Card"
            },
            z_report: {
                title: "End of Day Report (Z-Report)",
                auto_toggle: "Auto Z-Report",
                auto_desc: "At 00:00",
                close_button: "CLOSE DAY (Z-REPORT)",
                history_title: "Past Z-Reports",
                no_reports: "No reports yet.",
                receipt: {
                    title: "Z REPORT",
                    report_no: "Report No",
                    cashier: "Cashier",
                    total_sales: "TOTAL SALES",
                    tax_base: "Tax Base",
                    total_tax: "Total Tax",
                    payment_details: "Record Details",
                    cash: "Cash",
                    card: "Credit Card",
                    other: "Other",
                    end: "--- END ---"
                }
            },
            modals: {
                close_confirm: {
                    title: "Close Day?",
                    text: "This action will archive <strong>{{count}}</strong> open transactions and generate an official Z-Report. Cannot be undone.",
                    cancel: "Cancel",
                    confirm: "Confirm & Close"
                },
                expense: {
                    title: "Add Quick Expense",
                    date: "Date",
                    category: "Category",
                    amount: "Amount",
                    description: "Description",
                    optional: "Optional...",
                    set_default: "Set as default for category",
                    last_trx: "Last: {{amount}} ({{date}})"
                },
                processing: {
                    title: "Generating Z-Report...",
                    text: "Please wait, processing end of day..."
                }
            },
            liabilities: {
                pending: "Pending Records",
                label_today: "Today's Expense Share",
                label_week: "Weekly Expense Share",
                label_total: "Pending Recurring Records"
            }
        },
        settings: {
            general: "General Settings",
            titles: {
                general: "General",
                expenses: "Expenses",
                modifiers: "Modifiers",
                developer: "Developer"
            },
            descriptions: {
                general: "System, language and business settings",
                expenses: "Financial configuration",
                developer: "Tools for simulation and testing"
            },
            subscription: {
                active: "ACTIVE",
                inactive: "INACTIVE",
                expired: "EXPIRED",
                renew: "Renew",
                days_left: "Days Left",
                next_payment: "Next Period",
                period_start: "Start of Period",
                time_remaining: "Time Remaining",
                lite_plan: "Lite Plan",
                standard_plan: "Standard Plan"
            },
            business_identity: "Business Identity",
            financial: "Financial Settings",
            financial_desc: {
                currency_desc: "Symbol used throughout the system",
                pricing_desc: "Tax calculation method"
            },
            interface: {
                title: "Interface",
                scale: "UI Scale (Zoom)",
                scale_desc: "Adjust the scale for items that don't fit or appear too small/large.",
                note: "Note:",
                scale_note: "Auto-scaling is always active on screens smaller than 1366px."
            },
            operational: {
                title: "Working Hours & Shifts",
                start_hour: "Start Hour (0-23)",
                end_hour: "End Hour (0-23)",
                info_text: "This setting determines the time range shown on the **Dashboard** hourly sales chart when 'Work Hours' is selected. It is also used as a reference for staff shift reporting.",
                updated_alert: "Working hours updated."
            },
            shortcuts: {
                staff_desc: "Manage Waiters, Baristas and Admins"
            },
            backup: {
                title: "Data & Backup",
                backup_now: "Backup",
                backup_desc: "Download Database (.json)",
                restore: "Restore",
                restore_desc: "Select .json File",
                factory_reset: "Factory Reset",
                reset_desc: "All data will be erased and returned to initial state.",
                reset_button: "Reset Data",
                success_restore: "Backup successfully restored.",
                alerts: {
                    confirm_upload: "Backup restored. Do you want to upload this data to Cloud and sync? (Overwrite cloud data)",
                    sync_started: "Cloud sync started!",
                    confirm_download: "Data will be downloaded from cloud and merged. Continue?",
                    confirm_repair: "Server connection will be repaired. Continue?",
                    repair_success: "Repair successful! Refreshing page...",

                    login_required: "Please login first.",
                    force_upload_confirm: "All local data will be uploaded to cloud (Overwriting cloud data). This cannot be undone. Continue?"
                }
            },
            security: {
                reset_title: "Factory Reset",
                restore_title: "Restore from Backup",
                reset_text: "This action cannot be undone. All data (sales, products, stock) will be permanently deleted.",
                restore_text: "Current data will be deleted and data from the selected backup file will be loaded.",
                admin_required: "Admin Approval Required",
                enter_pin: "Please enter PIN",
                confirm_reset: "Delete & Reset",
                confirm_restore: "Start Restore"
            },
            messages: {
                updated: "Settings updated.",
                error: "An error occurred."
            },
            sync: {
                title: "Cloud Sync",
                pending: "{{count}} pending items",
                up_to_date: "All data is up to date",

                button: "Sync Now",
                force_upload: "Force Upload Data",
                alerts: {
                    offline: "No internet connection.",
                    prep_fail: "Upload preparation failed.",
                    download_error: "Download Error: ",
                    download_success: "Data downloaded:\n{{prods}} Products\n{{stocks}} Stock Items\n{{cats}} Categories\n{{staff}} Staff\n{{trans}} Transactions\n{{z}} Z-Reports",
                    sync_error: "Sync Error: ",
                    pending_upload: "Please upload pending changes first (Sync Button).",
                    cafe_id_missing: "Cafe ID not found.",
                    setup_error: "Setup error: Cafe ID not found. Please refresh page."
                }
            }
        },
        financials: {
            title: "Financial Settings",
            subtitle: "Tax Rates & Expense Categories",
            tabs: {
                taxes: "Taxes",
                expenses: "Expenses",
                history: "Expense History"
            },
            taxes: {
                title: "Tax Rates",
                active_rates: "Active Rates",
                rate_name: "Rate Name",
                rate_percent: "Rate %",
                description: "Description",
                add_new: "Add New Rate",
                category_mapping: "Category Tax Mapping"
            },
            expenses: {
                title: "Expense Categories",
                add_new: "Add Category",
                category_name: "Category Name",
                description: "Description",
                default_amount: "Default Amount",
                recurring: "Recurring (Monthly)",
                recurring_day: "Day of Month",
                distribute_daily: "Distribute Daily in Reports"
            },
            history: {
                title: "Expense History",
                filter_all: "All Categories",
                no_records: "No records found.",
                table: {
                    date: "Date",
                    category: "Category",
                    description: "Description",
                    amount: "Amount"
                }
            }
        },
        crm: {
            title: "CRM & Loyalty",
            subtitle: "Customer Management & Loyalty Program",
            give_points: "Give Points",
            qr_instruction: "Scan QR code for customer",
            generate_qr: "Generate QR",
            qr_description: "Show this QR code to the customer to add points to their wallet.",
            customer_list: "Customer List",
            search_placeholder: "Search Customer...",
            last_visit: "Last Visit:",
            eligible: "Reward Available!",
            settings_title: "Campaign Settings",
            target_points: "Target Points",
            reward_name: "Reward Name",
            preview: "Card Preview",
            target_label: "Target",
            coming_soon: "Coming Soon",
            tab_customers: "CUSTOMERS",
            tab_loyalty: "LOYALTY PROGRAM",
            add_customer: "Add Customer",
            edit_customer: "Edit Customer",
            form_name: "FULL NAME",
            name_placeholder: "e.g. John Doe",
            form_phone: "PHONE",
            form_email: "EMAIL",
            form_notes: "NOTES",
            total_spent: "TOTAL SPENT",
            debt: "BALANCE / DEBT",
            no_customers: "No customer records found.",
            loyalty_desc_future: "Advanced loyalty program features, point systems, campaign management, and digital wallet integration will be available soon.",
            alerts: {
                qr_failed: "Failed to generate QR Code. Please check your internet connection.",
                settings_updated: "Campaign settings updated."
            },
            customer_detail: "Customer Details",
            transactions: "Transaction History",
            make_payment: "Receive Record",
            adjust_balance: "Adjust Balance",
            add_debt: "Add Record",
            payment_amount: "Record Amount",
            payment_method: "Record Method",
            new_balance: "New Balance",
            current_debt: "Balance/Debt Status",
            confirm_adjustment: "Update Balance",
            history_table: {
                date: "Date",
                type: "Transaction",
                amount: "Amount",
                staff: "Staff"
            },
            trx_types: {
                order: "Order",
                debt_payment: "Payment",
                correction: "Correction"
            }
        },
        qr: {
            title: "QR Menu",
            subtitle: "Digital Menu & Ordering System",
            simulate: "Sipariş Simüle Et",
            print_selected: "Print Selected",
            lock: {
                title: "Online Services Locked",
                desc: "QR Menu and online ordering features are available in Standard Plan.",
                upgrade_btn: "Upgrade Plan"
            },
            print: {
                title: "Print QR Codes",
                scan_instruction: "Scan to View Menu"
            },
            preview: {
                title: "Live Preview",
                network: "Network:",
                password: "Pass:",
                powered_by: "Powered by KahveInn",
                disclaimer: "* This is a preview of how the QR stand will look.",
                scan_instruction: "Scan for Menu"
            },
            settings: {
                general: "General",
                active: "Active",
                active_desc: "Enable QR Menu system",
                ordering: "Allow Ordering",
                ordering_desc: "Customers can place orders",
                sound: "Sound Alert",
                sound_desc: "Play sound on new order",
                design: "Design",
                header_text: "Header Text",
                theme_color: "Theme Color",
                wifi_ssid: "Wi-Fi SSID",
                wifi_pass: "Wi-Fi Password"
            },
            selection: {
                title: "Table Selection",
                select_all: "Select All",
                previewing: "Previewing"
            },
            modal: {
                permission_title: "Permission Required",
                permission_text: "We need browser permission to play sound notifications.",
                allow_btn: "Allow Sound"
            },
            alerts: {
                audio_failed: "Audio failed. Please check browser permissions.",
                simulation_req: "Must have at least one table and product for simulation.",
                print_req: "Please select tables to print."
            }
        },
        staff: {
            title: "Staff Management",
            subtitle: "Employees and authorization",
            tabs: {
                list: "Staff List",
                roles: "Roles & Permissions"
            },
            lite_banner: {
                title: "Lite Plan",
                desc: "Advanced staff management is restricted."
            },
            stats: {
                total: "Total Staff",
                on_duty: "On Duty"
            },
            matrix: {
                person: "Person"
            },
            auto_shift_report: "Auto Shift Report",
            modal: {
                add_title: "Add Staff",
                edit_title: "Edit Staff",
                delete: "Delete Staff",
                name: "Full Name",
                role: "Role",
                pin: "PIN Code (4-digits)",
                phone: "Phone (Optional)",
                status: "Status",
                status_working: "Working",
                status_off: "Off Duty"
            },
            roles_tab: {
                title: "Roles",
                subtitle: "Customize role permissions",
                permissions: "Permissions",
                no_permissions: "No permissions assigned"
            },
            contact: "Contact",
            status: {
                working: "Working",
                offline: "Off Duty"
            },
            permission_matrix: "Permission Matrix",
            no_pin_permission: "No permission to view/change PIN",
            unauthorized_tooltip: "You cannot edit this user",
            alerts: {
                no_add_permission: "You do not have permission to add staff.",
                no_edit_others: "You can only edit your own profile.",
                no_edit_admin: "Only Admins can edit Admins.",
                no_delete_self: "You cannot delete yourself.",
                no_delete_permission: "You do not have permission to delete staff.",
                no_delete_admin: "Only Admins can delete Admins.",
                delete_confirm: "Are you sure you want to delete this staff member?",
                no_status_admin: "Only Admins can change Admin status.",
                only_admin_roles: "Only Admins can change role permissions."
            }
        },
        permission_groups: {
            general: "General",
            sales: "Sales",
            management: "Management"
        },
        permissions: {
            VIEW_FINANCIALS: { label: "View Financials", description: "Access revenue and profit data" },
            VIEW_TABLES: { label: "View Tables", description: "View table plan and orders" },
            MANAGE_MENU: { label: "Manage Menu", description: "Add and edit products" },
            MANAGE_STOCK: { label: "Manage Stock", description: "Inventory control" },
            VIEW_REPORTS: { label: "View Reports", description: "Access report pages" },
            MANAGE_STAFF: { label: "Manage Staff", description: "Add/remove staff" },
            MANAGE_SETTINGS: { label: "Manage Settings", description: "System configuration" },
            VOID_ITEM: { label: "Void Item", description: "Cancel or wastage operations" },
            OFFER_COMP: { label: "Offer Comp", description: "Permission to give free items" },
            APPLY_DISCOUNT: { label: "Apply Discount", description: "Apply discount to order" },
            CLOSE_DAY: { label: "Close Day", description: "Permission to take Z-Report" },
            VIEW_X_REPORT: { label: "View X-Report", description: "Can view the instant register report" },
            VIEW_Z_REPORT: { label: "View Z-Report", description: "Can view end-of-day closing reports" },
            VIEW_DETAILED_REPORT: { label: "View Detailed Report", description: "Can view the detailed Excel/P&L report" }
        },
        setup: {
            business_name: "Business Name",
            business_address: "Address",
            manager_name: "Manager Name",
            manager_hint: "Your name for manager profile",
            staff_count: "Staff Count",
            staff_hint: "Estimated number of employees",
            currency: "Currency",
            pricing_model: "Pricing Model",
            tax_inclusive: "Tax Inclusive",
            tax_exclusive: "Tax Exclusive",
            completing: "Completing Setup...",
            title_1: "Welcome",
            title_2: "Team & Management",
            title_3: "Financial Settings",
            desc_1: "Let's create your business identity.",
            desc_2: "Let's configure your team structure.",
            desc_3: "Select your currency and tax preferences.",
            skip_dev: "Skip (Dev)",
            back: "Back",
            next: "Next",
            finish: "Finish Setup",
            placeholders: {
                business_name: "e.g. KahveInn",
                city: "City (e.g. New York)",
                district: "District (e.g. Manhattan)",
                address_detail: "Street, Building No...",
                manager_name: "Your Full Name"
            },
            errors: {
                business_name: "Please enter business name.",
                city: "Please enter city.",
                district: "Please enter district.",
                address_detail: "Please enter full address.",
                manager_name: "Please enter manager name.",
                staff_count: "Please enter a valid staff count."
            },
            currencies: {
                try: "Turkish Lira (₺)",
                usd: "$ - US Dollar ($)",
                eur: "Euro (€)",
                gbp: "Pound Sterling (£)",
                krw: "South Korean Won (₩)",
                all: "Albanian Lek (L)",
                pln: "Polish Zloty (zł)",
                idr: "Indonesian Rupiah (Rp)",
                php: "Philippine Peso (₱)"
            },
            loading_text: "Your system is being prepared, please wait.",
            alerts: {
                reg_fail: "Server registration failed, but local setup continues. Check your internet connection."
            }
        },
        login: {
            // ... existing items ...
            alerts: {
                admin_restore_confirm: "Emergency: Restore Admin Role?",
                admin_restore_success: "SUCCESS: User '{{name}}' is now Admin. Please login.",
                no_staff_data: "ERROR: No staff data loaded yet. Please wait a moment and try again.",
                login_failed: "Login failed. Please try again."
            }
        },
        loyalty: {
            // ... existing items ...
            alerts: {
                qr_fail: "Could not generate QR Code. Check your internet connection.",
                campaign_updated: "Campaign settings updated."
            }
        },
        loading: {
            status: {
                starting: "Starting...",
                init_db: "Initializing database...",
                seeding: "Seeding default data...",
                refreshing: "Updating data...",
                ready: "Ready!"
            }
        },
        modifier: {
            // ... existing ...
            alerts: {
                delete_group_confirm: "Are you sure you want to delete this modifier group?",
                delete_option_confirm: "Are you sure you want to delete this option?"
            }
        }
    }
};
